import styled, { css } from 'styled-components';
export const Container = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: row;  
`;
export const Content = styled.div`
    display: flex;
    height: 100%;
    flex-direction: column;
    border-right: 1px solid #ccc;
    background-color: #e5ddd5;
    ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') && css`
        background-color: #ffffff;
    `}
    ${({ isOpen }) =>
        isOpen
            ? css`
            &{    
                width: calc(100% - 300px);
            }
        `
            : css`
            &{    
                width: 100%;
            }
        `
    }
`;
export const Menu = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    max-width: 300px;
    width: 0;
    width: ${({ isOpen }) => isOpen ? '300px' : '0'};
   
`;
export const Header = styled.div`
    display: flex;
    justify-content: space-around;
    border-bottom: 1px solid #ccc;
    background-color: #fff;

    ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') && css`
        border-bottom: 3px solid #000000;
    `}
`;
export const Info = styled.div`
    display: flex;
    width: 100%;
    min-height: 60px;
    align-items: center;
    padding: 0 1rem;
    gap: 1rem;
    .name{
        color: #000;
        font-size: 17px;
    }
    .phone{
        color: #999;
        font-size: 12px;
        margin-left: 10px;
    }
    .countdown{
        color: #999;
        font-size: 12px;
        margin-top: 0.2rem;
    }

    ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') && css`
        .name, .phone, .countdown {
            color: #000000 !important;
            font-weight: bold;
        }
        .phone, .countdown {
            font-size: 14px;
        }
    `}
`;
export const Actions = styled.div`
    display: flex;
    padding: 0 2rem;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    .cursor--pointer{
        cursor: pointer;
    }
    .open--call{
        font-size: 2rem;
        color: #919191;
    }
    .open--call:hover{
        color: #1b72d6;
    }
    .close--call{
        font-size: 3rem;
        color: #CC0000;
    }
    .invite--call{
        font-size: 1.5rem;
        color: #ffffff;
    }

    ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') && css`
        .open--call {
            color: #000000 !important;
        }
    `}
    .blob-cam-invite{
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      height: 40px;
      width: 40px;
      transform: scale(1);
      background-color: rgba(0,168,132, 1);
      box-shadow: 0 0 0 0  rgba(0,168,132, 1);
      animation: pulse-s 2s infinite;
      @keyframes pulse-s {
        0% {
          transform: scale(0.95);
          box-shadow: 0 0 0 0 rgba(0,168,132, 0.7);
        }
        70% {
          transform: scale(1);
          box-shadow: 0 0 0 10px rgba(0,168,132, 0);
        }
        100% {
          transform: scale(0.95);
          box-shadow: 0 0 0 0 rgba(0,168,132, 0);
        }
      }
    }
`;
export const CommentsNotification = styled.div`
    position: relative;
    .cont--{
        position: absolute;
        top: -10px;
        right: -15px;
        z-index: 9;
        padding: 2px;
        border-radius: 20px;
        background-color: #ffffff;
        .number--{
            font-size: 12px;
            font-weight: bolder;
            line-height: 1;
            color: #ffffff;
            height: 20px;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 6px;
        }
    }
    .comments--icon {
      display: flex;
      font-size: 2rem;
      color: #919191;
    }

    ${({ accessLevel }) =>
      accessLevel?.includes('ACESSIBILIDADE') &&
      css`
        .comments--icon {
          color: #000000 !important;
        }
      `}

    ${({ color }) =>
        color &&
        css`
        &{    
            .comments--icon{
                color: ${({ color }) => color};
            } 
            .number--{
                background-color: ${({ color }) => color};
            }
        }
    `}
`;
export const Body = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: flex-start;
    background-color: #e5ddd5;
    overflow-y: auto;
    padding: 20px 30px;
    margin-bottom: 10px;
    ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') && css`
        background-color: #ffffff;
        #btn-loadMore {
            button {
                background-color: #ffffff;
                color: #000000;
                border: 2px solid #000000;
            }
        }
    `}

    #btn-loadMore{
        display: flex;
        width: 100%;
        height: 2.5rem;
        justify-content: center;
        align-items: center;
        padding: 1rem;
        
        button{
            border: none;
            outline: none;
            width: 10rem;
            height: 2.5rem;
            color: rgb(73, 80, 87);
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 6px;
            cursor: pointer;
            font-weight: bold;
            &:hover{
                box-shadow: 0 1px 1px #b5b5b5;
            }
        } 
    }
    &::-webkit-scrollbar{
        width: 5px;
        height: 5px;
    }
    &::-webkit-scrollbar-thumb{
        background-color: rgb(0, 0, 0,0.2);
    }
    
`;
export const Footer = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 1rem;
    padding: 0 1rem;
    @keyframes moverRight {
        from {
            right: -100px;
        }
        to {
            right: 0px;
        }
    };
    ${({ disabled }) => disabled &&
        css`
        pointer-events: none;
        opacity: 0.7;
      `
    }; 
`;
export const GoUP = styled.div`
    position: absolute;
    display: flex;
    top: -6rem;
    right: -1px;
    width: 60px;
    height: 45px;
    justify-content: center;
    align-items: center;
    border-radius: 6px 0 0 6px;
    font-size: 1.75rem;
    cursor: pointer;
    box-shadow: 0 1px 1px rgba(0,0,0,.1);
    color: #919191;
    background-color: #f8f9fa;
    animation: moverRight 0.900s forwards;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    .icon--notifications{
        font-size: 1.5rem;
        color: #04d756;
    }

    ${({ accessLevel }) =>
      accessLevel?.includes('ACESSIBILIDADE') &&
      css`
        background-color: #ffffff !important;
        color: #000000 !important;
        border: 2px solid #000000;
      `}
`;
export const ExpandBox = styled.div`
    display: flex;
    width: 100%;
    max-width: 1000px;
    height: ${({ openBoxExpand }) => openBoxExpand ? '400px' : '0px'};
    overflow: hidden;
    transition: height 0.5s ease;
    padding: 0 0.2rem;
    
    ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') && css`
        background-color: #ffffff;
        border-top: 2px solid #000000;
    `}

    .messageTemplate{
        box-shadow: none;
    }
`;
export const Controls = styled.div`
    display: flex;
    position: relative;
    width: 100%;
    max-width: 1000px;
    min-height: 50px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    overflow: hidden;

    ${({ accessLevel }) =>
      accessLevel?.includes('ACESSIBILIDADE') &&
      css`
        background-color: #ffffff !important;

        .icon-- {
          color: #000000 !important;
          &:hover {
            color: #000000 !important;
          }
        }

        textarea {
          background-color: #ffffff !important;
          color: #000000 !important;
        }

        button:not(.close-customer-btn) {
          background-color: #ffffff !important;
          color: #000000 !important;
          &:hover {
           background-color: #000000 !important;
           color: #ffffff !important;
          }
          border: 3px solid #000000 !important;
          font-weight: 900 !important;
          box-shadow: none !important;

          svg {
            color: #000000 !important;
          }
        }
      `}

    > div:nth-child(1) {
        display: flex;
        width: 100%;
        height: 100%;
        flex-direction: row;
        overflow: hidden;
    };

    > div:nth-child(2){
        display: flex;
        position: absolute;
        z-index: 99;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        background-color: #f5f5f5;
        overflow: hidden;

        ${({ isAllowSelection }) => isAllowSelection
        ? css`
                &{    
                    animation: anim-open 0.2s ease-out;
                    transform: translateY(0%);
                }`
        : css`
                &{    
                    animation: anim-close 0.2s ease-out;
                    transform: translateY(100%);
                }`
    }
    };
    @keyframes anim-open {
        from {
            transform: translateY(100%);
        }
        to {
            transform: translateY(0%);
        }
    }
    @keyframes anim-close {
        from {
            transform: translateY(0%);
        }
        to {
            transform: translateY(100%);
        }
    }
`;
export const RenderControls = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items:center;
    padding: 10px;
    .ref--end{
        display: flex;
        width: 100%;
        height: 100%;
        gap: 1rem;
        justify-content: center;
        align-items:end;
    }
    .icon--{
        display: flex;
        width: 20px;
        height: 30px;
        min-height: 30px;
        justify-content: center;
        align-items: center;
        color: #919191;
        font-size: 1.5rem;
        cursor: pointer;
    }
    .icon--:hover{
      color: #1b72d6;
    }
    .magicWand{
        transform: rotate(80deg);
    }
    ${({ isHidden }) => isHidden &&
        css`
            visibility: hidden;
            pointer-events: none;  
        `
    };
`;
export const Send = styled.button`
    outline: none;
    border: none;
    display: flex;
    width: auto;
    height: auto;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    margin-right :5px;
    cursor: pointer;
    padding: 0.3rem;
    color: #ffffff;
    background-color: #1b72d6;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;
export const RenderVoiceRecorder = styled.div`
    position: relative;
    align-self: center;
    width: ${({ isOpen }) => isOpen ? '20rem' : '0px'};
    right:${({ isOpen }) => isOpen ? '20px' : '0px'} ;
    transition: width 0.2s ease-out;
`;
export const SelectFile = styled.input.attrs({ type: 'file' })`
    display: none;
`;
export const CloseCustomerService = styled.div`
    display: flex;
    height: auto;
    width: 15rem;
    justify-content: center;
    align-items: end;
    border-radius: 4px;
    user-select: none;

    ${({ disabled }) => disabled && css`
        opacity: 0.5;
        cursor: not-allowed;
        button {
            cursor: not-allowed !important;
            pointer-events: none;
        }
    `}

    button{
        height: 30px;
        width: 100%;
        outline: none;
        background-color: ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') ? '#ffffff' : '#1b72d6'};
        color: ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') ? '#000000' : '#ffffff'};
        border: ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') ? '1px solid #000000' : 'none'};
        border-radius: 4px;
        font-size: 11.75px;
        text-align: center;
        cursor: pointer;
        white-space: break-spaces;
        &:hover{
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
    }
    .load{
        display: flex;
        height: 30px;
        width: 100%;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        background-color: #1b72d6;
    }
`;
export const LoadMore = styled.div`
    display: flex;
    height: 4rem;
    width: 100%;
    margin-bottom: 4rem;
    justify-content: center;
    align-items: center;
    button{
        display: flex;
        width: 10rem;
        height: 2.5rem;
        color: #495057;
        background-color: rgba(0, 0, 0, .10);
        border-radius: 6px;
        border: none;
        font-weight: 700;
        justify-content: center;
        align-items: center;
        transition: filter 0.1s;
        transition: all 0.7s ease;
        cursor: pointer;
    }
`;
export const LoadMoreSpinerLoading = styled.div`
    border: 3px solid transparent;
    border-radius: 50%;
    border-top: 2.5px solid rgba(0, 0, 0, .4);
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
export const LoadCustomerServiceClose = styled.div`
    border: 3px solid transparent;
    border-radius: 50%;
    border-top: 2.5px solid #ffffff;
    width: 25px;
    height: 25px;
    animation: spin 1s linear infinite;
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
export const LoadSendMessage = styled.div`
    display: inline-block;
    position: relative;
    width: 50px;
    height: 100%;
    div {
        position: absolute;
        width: 6px;
        height: 6px;
        bottom: 10px;
        border-radius: 50%;
        background-color: #909497;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    div:nth-child(1) {
        left: 4px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    div:nth-child(2) {
        left: 4px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    div:nth-child(3) {
        left: 16px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    div:nth-child(4) {
        left: 16px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(10px, 0);
        }
    }
`;
export const AreaMessagesGenerated = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    border-radius: 8px 8px 0 0;
    background-color: #f6f6f6;
    padding: 0.9rem;
    overflow-y:auto;
    .icClose{
        font-size: 1.7rem;
        color: #8c8787;
        cursor: pointer;
    }
    > div:nth-child(1){
        width: 100%;
        height: 30px;
    }
    > div:nth-child(2){
        display: flex;
        width: 100%;
        height: calc(100% - 30px);
        gap: 0.5rem;
        border-radius: 8px 8px;
        padding: 0.5rem;
        flex-direction: column;
        background-color: #ffffff;
        &::-webkit-scrollbar{
            width: 5px;
            height: 5px;
        }
        &::-webkit-scrollbar-thumb{
            background-color: rgb(0, 0, 0,0.2);
        }
    }
`;

export const StyleEmoji = styled.div`
    position: relative;
    display: flex;
    justify-content: end;
`;

export const AccessibilityModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 1rem;
  background-color: #ffffff;
  color: #000000;
  border: 3px solid #000000;
  border-radius: 20px;
  min-width: 550px;
  max-width: 90vw;
  max-height: 80vh;
  overflow-y: auto;
  forced-color-adjust: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #000000;
    border-radius: 10px;
    border: 2px solid #ffffff;
  }

  .item {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    padding: 0.8rem;
    border: 3px solid #000000;
    border-radius: 12px;
    background-color: #ffffff;
    position: relative;
    box-shadow: 0 0 0 2px #000000 inset;

    .open--call,
    .dropdown-arrow {
      font-size: 1rem !important;
      color: #000000 !important;
    }

    .video-call-button {
      padding: 0.5rem !important;
      border: 3px solid #ffffff !important;
      border-radius: 10px;
      background-color: #ffffff !important;
      width: fit-content;
      font-weight: 700;
    }

    & > div:last-child {
      div {
        background-color: #ffffff !important;
        border: 2px solid #ffffff !important;
      }

      span {
        color: #000000 !important;
        font-weight: 900 !important;
      }
    }
  }

  .label {
    font-size: 1rem;
    color: #000000;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 800;
  }

  .value {
    font-size: 1rem;
    word-break: break-word;
    color: #000000;
    margin-bottom: 0.3rem;
    line-height: 1.3;
    font-weight: 600;
  }

  .access-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;

    padding: 0.6rem;

    font-size: 1rem;
    font-weight: 900;

    cursor: pointer;

    border: 3px solid #ffffff;
    border-radius: 10px;

    background-color: #ffffff;
    color: #000000;

    width: 100%;
    text-transform: uppercase;
    &:active {
      transform: scale(0.98);
    }

    &:focus {
      outline: 3px solid #000000;
      outline-offset: 3px;
    }

    svg {
      font-size: 1rem;
    }
  }

  .video-call-btn {
    background-color: #ffffff !important;
    color: #000000 !important;
    border: 3px solid #ffffff !important;
  }

  @media (forced-colors: active) {
    border: 2px solid CanvasText;

    .access-button {
      border: 2px solid ButtonText;
      background: ButtonFace;
      color: ButtonText;
    }
  }

    .access-button {
      border-width: 4px;
      font-weight: 950;
    }
  }
`;

export const VideoOptionsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1.2rem;
  width: 100%;

  .access-button {
    flex: 1;
    min-height: 45px;
    min-width: 120px;
    font-size: 0.9rem;
  }
`;